import { BaseCommand } from './BaseCommand';
import { goto } from '$app/navigation';
import AdminService from '$lib/services/AdminService';
import { UserService } from '$lib/services/UserService';
import { resetPassword } from '$lib/firebase/auth';

export class CreateUserCommand extends BaseCommand {
  getKeywords() {
    return ['create', 'user'];
  }

  parameterDescriptions = [
    { key: 'name', description: 'The name of the user' },
    { key: 'email', description: 'The email address of the user' },
  ];

  async getUser(email: string) {
    try {
      const user = await UserService.queryByEmail(email);
      return user;
    } catch (e) {
      return null;
    }
  }

  async action(parameters: string[], onMessage?: (message: string) => void) {
    const name = this.parameters[0];
    const email = this.parameters[1];
    if (!email) {
      throw new Error('Please provide an email address');
    }
    if (!email.includes('@')) {
      throw new Error('Please provide a valid email address');
    }
    try {
      await AdminService.createUser(name, email);
      onMessage?.('User created, redirecting to user page');
      const response = await window.bulmaConfirm(
        'Do you want to send a password reset email to the user?',
      );
      if (response) {
        try {
          await resetPassword(email);
        } catch (e: any) {
          if (e.code !== 'auth/user-not-found') {
            throw e;
          }
        }
      }
      goto(`/admin/user/${email}`);
    } catch (e: any) {
      console.error(e);
      let errMsg = e.message;
      try {
        const parsed = JSON.parse(e.message);
        if (parsed && typeof parsed === 'object' && parsed.message) {
          errMsg = parsed.message;
        }
      } catch {
        // use original e.message
      }
      throw new Error(`Error creating user: ${errMsg}`);
    }
  }
}
